module.exports = __webpack_public_path__ + "static/woman-nature-square.edcd4ec1.jpg";